function getCurrentStep(pathname) {
  if (pathname.includes("/products/")) {
    return 1;
  } else if (
    pathname.includes("/bundle") ||
    pathname.includes("/pages/bundle")
  ) {
    return 2;
  } else if (pathname.includes("/cart")) {
    return 3;
  }
  return 1;
}

function setStepProgress(currentStep) {
  document
    .querySelectorAll(".progressive-stepper__step")
    .forEach((step, index) => {
      step.classList.remove(
        "progressive-stepper__step--completed",
        "progressive-stepper__step--active"
      );

      if (index < currentStep - 1) {
        step.classList.add("progressive-stepper__step--completed");
      } else if (index === currentStep - 1) {
        step.classList.add("progressive-stepper__step--active");
      }
    });
}

const currentStep = getCurrentStep(window.location.pathname);
setStepProgress(currentStep);
